import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import LabelCase from "src/Component/LabelCase";
import VideoPlayer from "src/Component/VideoPlayer";
import CustomUL from "src/Component/CustomUl";

// Constants
const PAGE_ID = 3;
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;
const BG_ID = 3;
const BG_TYPE = "jpg";

const LEFT_TITLE = "TOSCA template generation\nusing Standard LLM";
const LEFT_LIST_ITEM_1 = "Prompts from network engineer transformed into<br/>TOSCA template";
const LEFT_LIST_ITEM_2 = "Generated TOSCA template available for editing,<br/>validation and download";
const LEFT_LIST_ITEM_3 = "Improved productivity avoiding human errors and<br/>design inconsistencies";

const DATA = (): DataMainTemplate => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const items: string[] = [LEFT_LIST_ITEM_1, LEFT_LIST_ITEM_2, LEFT_LIST_ITEM_3];

  const backButton = {
    label: "Back",
    type: "back" as const,
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BACK_PAGE_ID),
  };

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
  };

  return {
    bgVideo: {
      poster: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
      video: `${Config.BASE_URL}/videos/bg_${BG_ID}.mp4`,
    },
    gradient:
      "linear-gradient(270deg, rgba(21, 50, 121, 0.00) 11.77%, #153279 87.81%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%)",
    title: LEFT_TITLE,
    leftBeforeTitle: <LabelCase label={"USE CASE 1"} />,
    leftAfterDescription: <CustomUL items={items} />,
    rightSideComponent: <VideoPlayer src={`${Config.BASE_URL}/screen_${PAGE_ID}.mp4`} pageId={PAGE_ID} />,
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
